module.exports = __webpack_public_path__ + "img/cd33892909eccb0563f5c7d59ec4600b.png";